// extracted by mini-css-extract-plugin
export default {"use_terms_container":"styles_use_terms_container__yBj7K"};